// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb1b087a","732":"203eff70"}[chunkId] + ".chunk.js";
};